import { module } from 'angular';
import MainDirective from './main.directive';
import MainController from './main.controller';
import LangController from './lang.controller';
import './main.scss';

export default module('app.main', [])
	.directive('main', MainDirective)
	.controller('MainController', MainController)
	.controller('LangController', LangController)
	.name;
